module.exports = __webpack_public_path__ + "static/media/foto_vehiculo_dorso.123ec6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/foto_vehiculo_dorso.jpg
// module id = 350
// module chunks = 0